import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    init: (state, data) => { state.list = data.sort((a, b) => b.name - a.name) }
  },
  actions: {
    init (state) { socket.get('SportSportSeason', 'Sport/Season/init') }
  },
  getters: {
    list: (state) => state.list,
    get: (state) => (id) => state.list.find(item => item.id === id)
  }
}
